import { DataProcessingService } from '@/libraries/usercentrics/types';
import { SnowplowContext } from './snowplow-contexts';
import { useUserAgent } from '@/helpers/composables/useUserAgent';
import { TrackingProvider, TrackingProviderPropertiesInterface } from './tracking-provider';
import { paToParentIDMap } from '@/helpers/tracking/util/paParentMapping';
import Cookies from 'js-cookie';

declare global {
	interface Window {
		dataLayer: any[];
	}
}

export class TrackingProviderGoogleTagManager extends TrackingProvider {
	dataProcessingService = DataProcessingService.GOOGLE_TAG_MANAGER;
	constructor(private config: { containerId: string; doNotTrack: boolean }) {
		super();
	}

	initialize() {
		return new Promise<void>(resolve => {
			// pre-init
			window.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });

			const f = document.getElementsByTagName('script')[0],
				j = document.createElement('script'),
				dl = 'dataLayer' != 'dataLayer' ? '&l=' + 'dataLayer' : '';
			j.async = true;
			j.src = 'https://www.googletagmanager.com/gtm.js?id=' + this.config.containerId + dl;
			f.parentNode!.insertBefore(j, f);

			resolve();
		});
	}

	async trackPage({ path }: { path?: string; title?: string }) {
		window.dataLayer.push({
			event: 'content-view',
			'content-name': path,
			userId: undefined,
		});
	}

	refreshPermanentAudiences(permanent_audiences: string[] = []) {
		if (this.config.doNotTrack || permanent_audiences.length === 0) return;
		// some of the PAs have a `pa:` prefix
		const pa_ids = permanent_audiences.map(pa => pa.split('pa:').at?.(-1) ?? '');
		const parent_list_id = pa_ids
			.filter(pa => pa in paToParentIDMap)
			.flatMap(pa => paToParentIDMap[pa])
			.map(({ listId }) => listId);

		const fbp = Cookies.get('_fbp');

		window.dataLayer.push({
			event: 'permanent_audiences',
			u9: pa_ids.join(';'),
			t8: parent_list_id.join(';'),
			...(fbp && { fbp }),
		});
	}

	refreshPermanentAudiencesSubgenres(permanent_audiences: string[]): void {
		if (this.config.doNotTrack || permanent_audiences.length === 0) return;
		const pa_ids = permanent_audiences.map(pa => pa.split('pa:').at?.(-1) ?? '');
		const fbp = Cookies.get('_fbp');

		window.dataLayer.push({
			event: 'permanent_audiences',
			u9: pa_ids.join(';'),
			...(fbp && { fbp }),
		});
	}
	async trackEvent(category: string, properties: TrackingProviderPropertiesInterface, contexts: SnowplowContext[]) {
		const { deviceInfo } = useUserAgent();

		properties = properties || {};
		window.dataLayer.push({
			event: 'interaction',
			target: category,
			action: properties.action,
			'target-properties': properties.label,
			value: properties.value,
			'interaction-type': properties.nonInteraction,
			userId: undefined,
			device: deviceInfo.value,
		});
	}
}
